<!-- HillScene.vue - the hill at the end of the landing page (was public/landing_content_bottom.svg), animated.
     Figma: "Content pages redesign" > Landing-Abschluss > "Hügel animiert". Plays once (4 s) when it scrolls into
     view and stays on the end frame (no endless loop, WCAG 2.2.2). With reduced motion it is simply the still image.
     The rider moves by rotating around the hill's centre (the hill is a circle), so it follows the slope like a real
     ride. The viewBox has 64 extra units on top so the raised magic wand is not cut off. Decorative: hidden from
     screen readers. -->
<template>
  <svg ref="svg" class="hill" :class="{ play }" viewBox="0 -64 578 323" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <circle cx="289.5" cy="327.5" r="255.5" style="fill: var(--ill-mint)" />
    <circle cx="289.5" cy="221.5" r="115.5" style="fill: var(--ill-mint-soft)" />
    <g class="tree">
      <rect x="490.104" y="94.2738" width="15.1265" height="53.7047" transform="rotate(40.8087 490.104 94.2738)" style="fill: var(--ill-steel)" />
      <ellipse cx="512.152" cy="80.3125" rx="29.608" ry="29.6666" transform="rotate(40.8087 512.152 80.3125)" style="fill: var(--ill-mint)" />
      <ellipse opacity="0.6" cx="497.146" cy="56.1251" rx="22.8069" ry="22.8069" transform="rotate(40.8087 497.146 56.1251)" style="fill: var(--ill-mint)" />
    </g>
    <g class="ride">
      <g class="rider">
        <path opacity="0.9" style="fill: var(--ill-ink)" d="M101.683 64.8342C99.0838 66.8497 98.6169 70.5414 100.632 73.1406C102.648 75.7397 106.34 76.2067 108.939 74.1912C111.538 72.1757 112.005 68.484 109.989 65.8848C107.974 63.2856 104.282 62.8187 101.683 64.8342ZM98.1709 79.6275C96.9493 80.5748 96.2146 81.9353 96.0597 83.3457L93.88 100.394C93.699 101.824 94.0114 103.247 95.0191 104.547C96.2889 106.184 98.2148 106.897 100.191 106.654L112.99 105.179L123.067 118.174L127.746 114.546L114.645 97.652L105.471 97.8982L106.765 87.1143L116.3 90.1254L127.217 81.6603L123.589 76.9818L115.272 83.4314L103.639 78.8422C101.877 78.1271 99.7304 78.4182 98.1709 79.6275ZM89.7159 81.6056L71.5218 95.7141C70.0923 96.8226 68.0157 96.5599 66.9072 95.1304C65.7986 93.7009 66.0613 91.6243 67.4908 90.5158L92.9366 70.7841C93.076 72.0911 93.3799 73.3954 93.9522 74.6164C91.7572 76.4017 90.2968 78.866 89.7159 81.6056ZM94.8595 115.075C87.6859 120.638 86.3784 130.975 91.9412 138.149C97.504 145.322 107.841 146.63 115.014 141.067C122.188 135.504 123.496 125.167 117.933 117.994C112.37 110.82 102.033 109.513 94.8595 115.075ZM111.991 137.168C106.975 141.058 99.7298 140.142 95.8399 135.125C91.95 130.109 92.8664 122.864 97.8828 118.974C102.899 115.084 110.144 116.001 114.034 121.017C117.924 126.033 117.008 133.278 111.991 137.168ZM131.248 86.8586C124.074 92.4214 122.767 102.758 128.329 109.932C133.892 117.106 144.229 118.413 151.403 112.85C158.576 107.287 159.884 96.9506 154.321 89.7769C148.758 82.6033 138.421 81.2959 131.248 86.8586ZM148.379 108.951C143.363 112.841 136.118 111.925 132.228 106.909C128.338 101.892 129.255 94.6472 134.271 90.7573C139.287 86.8674 146.532 87.7838 150.422 92.8002C154.312 97.8165 153.396 105.062 148.379 108.951ZM93.6758 111.831L82.4474 120.538C81.0127 121.651 78.9413 121.384 77.8328 119.955C76.7243 118.525 76.9817 116.453 78.4164 115.34L88.943 107.177C89.2135 107.633 89.4782 108.136 89.8208 108.578C90.889 109.955 92.2288 111.039 93.6758 111.831ZM87.3812 100.064L76.9846 108.126C75.5551 109.235 73.4785 108.972 72.37 107.543C71.2614 106.113 71.5241 104.036 72.9536 102.928L88.4706 90.8954L87.3531 99.5449C87.3298 99.7295 87.3006 99.9602 87.3812 100.064Z" />
        <path d="M118 70 L160 22" style="stroke: var(--ill-ink)" stroke-width="7" stroke-linecap="round" />
        <path d="M152 31 L160 22" style="stroke: var(--ill-wand)" stroke-width="7" stroke-linecap="round" />
        <path class="spark s1" d="M168 8 L171 16 L179 19 L171 22 L168 30 L165 22 L157 19 L165 16 Z" style="fill: var(--ill-spark)" />
        <path class="spark s2" d="M182 30 L184 35 L189 37 L184 39 L182 44 L180 39 L175 37 L180 35 Z" style="fill: var(--ill-spark)" />
      </g>
    </g>
    <path d="M289 117.5L300.547 97.5L277.453 97.5L289 117.5ZM291 87.5L291 77.5L287 77.5L287 87.5L291 87.5Z" style="fill: var(--ill-paper)" />
    <path class="dash" d="M289 63V19" style="stroke: var(--ill-ink)" stroke-width="4" stroke-dasharray="15 15" />
  </svg>
</template>

<script>
import { useScene } from '@/anim/useScene';

export default {
  name: 'HillScene',
  setup() {
    const { root, play, gsapOn } = useScene();
    return { svg: root, play, gsapOn };
  },
};
</script>

<style scoped>
.hill { display: block; width: 100%; height: auto; overflow: hidden; }
.hill * { transform-box: view-box; }
/* Rotation around the hill's centre moves the rider along the arc and tilts it with the slope. */
.ride { transform-origin: 289.5px 327.5px; }
.tree { transform-origin: 458px 134px; }
.spark { transform-box: fill-box; transform-origin: center; }

.play .ride { animation: ride 4s cubic-bezier(0.45, 0, 0.3, 1) forwards; }
.play .spark { animation: twinkle 0.8s ease-in-out 3 both; }
.play .s2 { animation-delay: 0.25s; }
.play .dash { animation: flow 2.4s ease-out 1.2s both; }
.play .tree { animation: sway 1.6s ease-in-out 1.8s both; }

@keyframes ride {
  0% { transform: rotate(0deg); }
  50% { transform: rotate(45deg); }
  100% { transform: rotate(56deg); }
}
@keyframes twinkle {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(0.3); opacity: 0.4; }
}
@keyframes flow {
  from { stroke-dashoffset: 0; }
  to { stroke-dashoffset: -60; }
}
@keyframes sway {
  0%, 100% { transform: rotate(0deg); }
  35% { transform: rotate(4deg); }
  70% { transform: rotate(-3deg); }
}
@media (prefers-reduced-motion: reduce) {
  .play * { animation: none !important; }
}
</style>
